module.exports = __webpack_public_path__ + "static/media/9.e4715a3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/9.jpg
// module id = 170
// module chunks = 0